import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { Utils } from "src/app/common/utils";
import { DateField } from "../models/field-date";

@Component({
  selector: "sd-form-field-date",
  templateUrl: "./sd-form-field-date.component.html",
  styleUrls: ["./sd-form-field-date.component.css"],
})
export class SdFormFieldDateComponent implements OnInit {
  @Input() formField: DateField;
  @Input() control: UntypedFormControl;
  @Input() formGroup: UntypedFormGroup;
  @Output() ondateSelectEvent: EventEmitter<any> = new EventEmitter();

  minDate: any; // = Utils.minDate;

  constructor() { }

  ngOnInit() {
    this.minDate = this.formField.minDate || Utils.minDate;
  }

  dateSelectEvent(key) {
    this.ondateSelectEvent.emit(key);
  }
}
